/**
 * Format a number as Uzbek currency (so'm) or time/days dynamically
 */
export const formatCurrency = (value, key = '') => {
  if (value === null || value === undefined) return '—';
  let cleanValue = value;
  if (typeof cleanValue === 'string') {
     cleanValue = cleanValue.replace(' ', '').replace(',', '.');
  }
  const num = parseFloat(cleanValue);
  if (isNaN(num)) return typeof value === 'string' ? value : '—';
  
  const kl = String(key).toLowerCase();
  
  // Custom logic for time, days, shifts
  if (kl.includes('haqiqatda ishlagan vaqt') || kl.includes('ҳақиқатда ишлаган вақт')) {
     return new Intl.NumberFormat('uz-UZ').format(num) + " soat";
  }
  if (kl.includes('kun') || kl.includes('кун')) {
     return new Intl.NumberFormat('uz-UZ').format(num) + " kun";
  }
  if (kl.includes('smena') || kl.includes('смена')) {
     return new Intl.NumberFormat('uz-UZ').format(num) + " smena";
  }

  return new Intl.NumberFormat('uz-UZ').format(num) + " so'm";
};

const UZ_MONTHS = [
  "Yanvar", "Fevral", "Mart", "Aprel", "May", "Iyun", 
  "Iyul", "Avgust", "Sentabr", "Oktabr", "Noyabr", "Dekabr"
];

const UZ_WEEKDAYS = [
  "Yakshanba", "Dushanba", "Seshanba", "Chorshanba", "Payshanba", "Juma", "Shanba"
];

export const formatDateUz = (dateObj) => {
  if (!dateObj) return '—';
  const d = new Date(dateObj);
  return `${d.getDate()}-${UZ_MONTHS[d.getMonth()]}, ${d.getFullYear()}-yil, ${UZ_WEEKDAYS[d.getDay()]}`;
};

export const formatDateTimeUz = (dateObj) => {
  if (!dateObj) return '—';
  const d = new Date(dateObj);
  const hours = String(d.getHours()).padStart(2, '0');
  const mins = String(d.getMinutes()).padStart(2, '0');
  return `${d.getDate()}-${UZ_MONTHS[d.getMonth()]} ${hours}:${mins}`;
};

/**
 * Format a YYYY-MM month string to human-readable
 * e.g. "2024-09" → "Sentabr 2024"
 */
export const formatMonth = (month) => {
  if (!month) return '—';
  const [year, mon] = month.split('-');
  return `${UZ_MONTHS[parseInt(mon) - 1]} ${year}`;
};

/**
 * Format phone number for display
 */
export const formatPhone = (phone) => {
  if (!phone) return '—';
  const digits = phone.replace(/\D/g, '');
  if (digits.length === 12 && digits.startsWith('998')) {
    return `+998 ${digits.slice(3, 5)} ${digits.slice(5, 8)} ${digits.slice(8, 10)} ${digits.slice(10)}`;
  }
  return phone;
};

/**
 * Truncate JSHSHIR for privacy display
 */
export const maskJshshir = (jshshir) => {
  if (!jshshir || jshshir.length < 6) return jshshir;
  return jshshir.slice(0, 4) + '••••••' + jshshir.slice(-4);
};

/**
 * Status badge config
 */
export const getStatusConfig = (status) => {
  const map = {
    success:    { label: 'Muvaffaqiyatli', color: '#10b981', bg: '#d1fae5' },
    partial:    { label: 'Qisman',         color: '#f59e0b', bg: '#fef3c7' },
    failed:     { label: 'Xato',           color: '#f43f5e', bg: '#ffe4e6' },
    processing: { label: 'Jarayonda',      color: '#0ea5e9', bg: '#e0f2fe' },
  };
  return map[status] || { label: status, color: '#64748b', bg: '#f1f5f9' };
};
